import { Crop } from '@crops';
import { atom } from 'recoil';

type Props = {
  data: {
    resourceText?: {
      imageNm: string;
      portDate: string;
    };
    aiDetailList?: Crop.TAiListResponse;
    cultureList?: {
      total: {
        tot_area: number;
        tot_count: number;
      };
      data: {};
    };
  };
  status: {
    aiDetail: {
      isOpen: boolean;
      data: any;
      detailType?: 'ai' | 'culture';
    };
    aiTransition: {
      isOpen: boolean;
    };
    cultureDetail: {
      isOpen: boolean;
      detailId?: {
        userIdnt: string;
        pnu: string;
        addr?: string;
        wkt: string;
      };
      detailType?: 'ai' | 'culture';
    };
    cultureTransition: {
      isOpen: boolean;
    };
    tillageDetail: {
      isOpen: boolean;
      detailId?: string;
      tillage?: string;
      addr?: string;
      area?: string;
      filePathNm?: string;
      thum_path_nm?: string;
      obj_seq?: string;
      pnu?: string;
    };
    searchMode: 'addr' | 'area';
    currentSearchMode: 'addr' | 'area';
    currentPage: 'ai' | 'culture';
    currentDetId: string;
    currentPrjId: string;
    currentYear: string;
    isFold: boolean; // 접힘 여부
    isLoading: boolean;
    isOpen: boolean;
    currentSearchAddr: string;
    currentSgg: string;
    currentEmd: string;
  };
};

const pannelState = atom<Props>({
  key: 'pannelState',
  default: {
    data: {
      resourceText: {
        imageNm: '-',
        portDate: '-',
      },
      aiDetailList: {
        total: {
          totalarea: 0,
          total: 0,
        },
        data: [],
      },
      cultureList: {
        total: {
          tot_area: 0,
          tot_count: 0,
        },
        data: [],
      },
    },
    status: {
      tillageDetail: {
        isOpen: false,
        detailId: '',
      },
      aiDetail: {
        // ai 분석결과 - 상세화면
        isOpen: false,
        data: {},
        detailType: 'ai',
      },
      cultureDetail: {
        // 재배면적신고내역 - 상세화면
        isOpen: false,
        detailType: 'ai',
      },
      aiTransition: {
        // ai 분석결과 - 변화추이
        isOpen: false,
      },
      // 재배 면적 신고 내역 - 변화추이
      cultureTransition: {
        isOpen: false,
      },
      searchMode: 'area',
      currentSearchMode: 'area',
      currentPage: 'ai',
      currentDetId: '',
      currentPrjId: '',
      currentYear: '',
      currentSearchAddr: '',
      currentSgg: '0',
      currentEmd: '0',
      isFold: true,
      isLoading: false,
      isOpen: false,
    },
  },
});

export default pannelState;
